import axios from 'axios'

const BASE_API_URL = 'https://api.repnode.com/Repnodeapi/api'

export const http = axios.create({
  baseURL: BASE_API_URL
})
